import LandingPageLayout from 'components/layout/landing/LandingPageLayout';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Home from 'screens/LandingPages/Home';
import { useHasLoginToken } from 'utils/hooks/useHasLoginToken';

function HomeIndex(props) {
  const hasLoginToken = useHasLoginToken();

  return (
    <LandingPageLayout
      title="OnBoard Crew App | Portal Lowongan Kerja dan Karier untuk Pelaut"
      description="Temukan dan lamar lowongan kerja pelaut terbaru. OnBoard Crew App menghubungkan pelaut profesional dengan perusahaan pelayaran secara cepat dan mudah."
      keywords="lowongan kerja pelaut, kerja di kapal, portal pelaut, seafarer job portal, rekrut pelaut, kerja kapal pesiar, kapal tanker, maritime jobs"
      hasLoginToken={hasLoginToken}
      {...props}
    >
      <Home {...props} />
    </LandingPageLayout>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'home'])),
    },
  };
}

export default HomeIndex;
